"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Button = _interopRequireWildcard(require("../Button"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _formik = require("formik");

var _forms = require("../utils/forms");

var _core = require("@material-ui/core");

var _excluded = ["loading", "success", "error", "children", "disabled", "className", "hideSuccessState", "size", "color", "variant"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var adornmentIconSize = 24;

var styles = function styles(theme) {
  return {
    hidden: {
      visibility: 'hidden'
    },
    error: {
      background: theme.palette.error.main
    },
    adornmentContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      height: adornmentIconSize,
      width: adornmentIconSize
    },
    adornment: {
      color: theme.palette.primary.contrastText
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var SubmitButton = function SubmitButton(_ref) {
  var loading = _ref.loading,
      success = _ref.success,
      error = _ref.error,
      children = _ref.children,
      disabled = _ref.disabled,
      className = _ref.className,
      hideSuccessState = _ref.hideSuccessState,
      size = _ref.size,
      color = _ref.color,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var context = (0, _formik.useFormikContext)(); // the double equals is to check for null or undefined

  var isStateSuccess = success != null ? success : (0, _forms.isSuccess)(context);

  var _ref2 = context || {},
      isSubmitting = _ref2.isSubmitting;

  var classes = useStyles();
  var showProgress = loading || isSubmitting;
  var successState = !hideSuccessState && isStateSuccess;
  var showSuccess = !loading && successState;
  var hideContent = showProgress || showSuccess;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    size: size,
    color: color,
    variant: variant
  }, props, {
    className: (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, classes.error, error)),
    type: "submit",
    disabled: disabled || loading
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.adornmentContainer
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: showProgress
  }, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    size: adornmentIconSize,
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.adornment, variant === 'contained'))
  })), /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: showSuccess
  }, /*#__PURE__*/_react["default"].createElement(_Check["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.hidden, hideContent))
  }, children));
};

SubmitButton.propTypes = (0, _extends2["default"])({}, _Button.ButtonProps, {
  /** If `true`, the component is in the loading state. */
  loading: _propTypes["default"].bool,

  /** If `true`, the component is in the success state. */
  success: _propTypes["default"].bool,

  /** If `true`, the component is in the error state. */
  error: _propTypes["default"].bool,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /** If `true`, the component is disabled. */
  disabled: _propTypes["default"].bool,
  hideSuccessState: _propTypes["default"].bool
});
SubmitButton.defaultProps = {
  loading: false,
  success: false,
  error: false,
  hideSuccessState: false
};
var _default = SubmitButton;
exports["default"] = _default;